export default __webpack_public_path__ + "static/media/open-your-mouth.61aab501.jpg";